import { render, staticRenderFns } from "./teacherPPTPage.vue?vue&type=template&id=97d6ee56"
import script from "./teacherPPTPage.vue?vue&type=script&lang=js"
export * from "./teacherPPTPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports